import { render, staticRenderFns } from "./NumerexList.vue?vue&type=template&id=0800fd97"
import script from "./NumerexList.vue?vue&type=script&lang=js"
export * from "./NumerexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports